import { PeriodInDays, TemplateType } from "@/domain/filter/filterType";

const template = (template: TemplateType) => {
  switch (template) {
    case TemplateType.receivables:
      return "Cobranças";
  }
};

const period = (period: PeriodInDays) => {
  switch (period) {
    case PeriodInDays.one:
      return "Ontem";
    case PeriodInDays.zero:
      return "Hoje";
    case PeriodInDays.seven:
      return "7 dias";
    case PeriodInDays.thirty:
      return "30 dias";
    case PeriodInDays.ninety:
      return "90 dias";
    default:
      return "Personalizado";
  }
};

export const translate = {
  template,
  period,
};
